/**
 * Create Ticket Page
 * Page for users to create new support tickets
 */

import { useState } from 'react'
import { Box, Container, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { CreateTicketForm } from '../components/CreateTicketForm'
import { createTicket } from '@api/services/tickets.api'
import { CreateTicketRequest } from '@api/types/tickets'

export default function CreateTicketPage() {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (request: CreateTicketRequest) => {
    setIsSubmitting(true)
    try {
      const ticket = await createTicket(request)
      // Navigate to the newly created ticket
      navigate(`/support/tickets/${ticket.id}`)
    } catch (error) {
      console.error('Failed to create ticket:', error)
      throw error
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleCancel = () => {
    navigate('/support/tickets')
  }

  return (
    <Container maxWidth="md" sx={{ py: 4, px: { xs: 0, sm: 3 } }}>
      <CreateTicketForm onSubmit={handleSubmit} onCancel={handleCancel} isSubmitting={isSubmitting} />
    </Container>
  )
}
